export interface ToolboxResponse {
    arguments: any;
    data: Array<string>;
    message: string;
    status: string;
}
